/* tslint:disable */
/* eslint-disable */
/**
 * Admin Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    PageUsersDTO,
    PageUsersDTOFromJSON,
    PageUsersDTOToJSON,
    PatchDocument,
    PatchDocumentFromJSON,
    PatchDocumentToJSON,
    UsersDTO,
    UsersDTOFromJSON,
    UsersDTOToJSON,
} from '../models';

export interface CreateUserRequest {
    usersDTO: UsersDTO;
}

export interface DeleteUserRequest {
    id: number;
}

export interface FindAllWithFailedOrcidConnectionByInstitutionRequest {
    institution: string;
    page?: number;
    size?: number;
    sort?: string;
}

export interface FindAllWithOrcidIdRequest {
    page?: number;
    size?: number;
    sort?: string;
}

export interface FindAllWithValidOrcidConnectionByInstitutionRequest {
    institution: string;
    page?: number;
    size?: number;
    sort?: string;
    direction?: string;
}

export interface FindOneWithOrcidIdByNameRequest {
    searchParameter: string;
    page?: number;
    size?: number;
    sort?: string;
}

export interface GetExternUserByUsernameRequest {
    username: string;
}

export interface GetUserRequest {
    id: number;
}

export interface GetUserByOrcidIDRequest {
    orcidId: string;
}

export interface GetUsersRequest {
    page?: number;
    size?: number;
    sort?: string;
}

export interface GetUsersByIdsRequest {
    userIds: Array<number>;
}

export interface PatchUserRequest {
    id: number;
    patchDocument?: Array<PatchDocument>;
}

export interface SearchUserRequest {
    searchParameter: string;
    page?: number;
    size?: number;
    sort?: string;
}

export interface SearchUserWithFailedOrcidRequest {
    searchParameter: string;
    institution: string;
    page?: number;
    size?: number;
    sort?: string;
}

export interface SearchUserWithValidOrcidRequest {
    searchParameter: string;
    institution: string;
    page?: number;
    size?: number;
    sort?: string;
}

/**
 * 
 */
export class UsersServiceApi extends runtime.BaseAPI {

    /**
     */
    async createUserRaw(requestParameters: CreateUserRequest): Promise<runtime.ApiResponse<UsersDTO>> {
        if (requestParameters.usersDTO === null || requestParameters.usersDTO === undefined) {
            throw new runtime.RequiredError('usersDTO','Required parameter requestParameters.usersDTO was null or undefined when calling createUser.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("OAuth2", []);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/user`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UsersDTOToJSON(requestParameters.usersDTO),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => UsersDTOFromJSON(jsonValue));
    }

    /**
     */
    async createUser(requestParameters: CreateUserRequest): Promise<UsersDTO> {
        const response = await this.createUserRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async deleteUserRaw(requestParameters: DeleteUserRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteUser.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("OAuth2", []);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/user/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteUser(requestParameters: DeleteUserRequest): Promise<void> {
        await this.deleteUserRaw(requestParameters);
    }

    /**
     */
    async findAllWithFailedOrcidConnectionByInstitutionRaw(requestParameters: FindAllWithFailedOrcidConnectionByInstitutionRequest): Promise<runtime.ApiResponse<PageUsersDTO>> {
        if (requestParameters.institution === null || requestParameters.institution === undefined) {
            throw new runtime.RequiredError('institution','Required parameter requestParameters.institution was null or undefined when calling findAllWithFailedOrcidConnectionByInstitution.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.institution !== undefined) {
            queryParameters['institution'] = requestParameters.institution;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("OAuth2", []);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/user/findAllWithFailedOrcidConnectionByInstitution`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PageUsersDTOFromJSON(jsonValue));
    }

    /**
     */
    async findAllWithFailedOrcidConnectionByInstitution(requestParameters: FindAllWithFailedOrcidConnectionByInstitutionRequest): Promise<PageUsersDTO> {
        const response = await this.findAllWithFailedOrcidConnectionByInstitutionRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async findAllWithOrcidIdRaw(requestParameters: FindAllWithOrcidIdRequest): Promise<runtime.ApiResponse<PageUsersDTO>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("OAuth2", []);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/user/findAllWithOrcidId`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PageUsersDTOFromJSON(jsonValue));
    }

    /**
     */
    async findAllWithOrcidId(requestParameters: FindAllWithOrcidIdRequest): Promise<PageUsersDTO> {
        const response = await this.findAllWithOrcidIdRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async findAllWithValidOrcidConnectionByInstitutionRaw(requestParameters: FindAllWithValidOrcidConnectionByInstitutionRequest): Promise<runtime.ApiResponse<PageUsersDTO>> {
        if (requestParameters.institution === null || requestParameters.institution === undefined) {
            throw new runtime.RequiredError('institution','Required parameter requestParameters.institution was null or undefined when calling findAllWithValidOrcidConnectionByInstitution.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.direction !== undefined) {
            queryParameters['direction'] = requestParameters.direction;
        }

        if (requestParameters.institution !== undefined) {
            queryParameters['institution'] = requestParameters.institution;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("OAuth2", []);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/user/findAllWithValidOrcidConnectionByInstitution`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PageUsersDTOFromJSON(jsonValue));
    }

    /**
     */
    async findAllWithValidOrcidConnectionByInstitution(requestParameters: FindAllWithValidOrcidConnectionByInstitutionRequest): Promise<PageUsersDTO> {
        const response = await this.findAllWithValidOrcidConnectionByInstitutionRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async findOneWithOrcidIdByNameRaw(requestParameters: FindOneWithOrcidIdByNameRequest): Promise<runtime.ApiResponse<PageUsersDTO>> {
        if (requestParameters.searchParameter === null || requestParameters.searchParameter === undefined) {
            throw new runtime.RequiredError('searchParameter','Required parameter requestParameters.searchParameter was null or undefined when calling findOneWithOrcidIdByName.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.searchParameter !== undefined) {
            queryParameters['searchParameter'] = requestParameters.searchParameter;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("OAuth2", []);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/user/findOneWithOrcidIdByName`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PageUsersDTOFromJSON(jsonValue));
    }

    /**
     */
    async findOneWithOrcidIdByName(requestParameters: FindOneWithOrcidIdByNameRequest): Promise<PageUsersDTO> {
        const response = await this.findOneWithOrcidIdByNameRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async getExternUserByUsernameRaw(requestParameters: GetExternUserByUsernameRequest): Promise<runtime.ApiResponse<UsersDTO>> {
        if (requestParameters.username === null || requestParameters.username === undefined) {
            throw new runtime.RequiredError('username','Required parameter requestParameters.username was null or undefined when calling getExternUserByUsername.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.username !== undefined) {
            queryParameters['username'] = requestParameters.username;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("OAuth2", []);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/user/findOneByUsername`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => UsersDTOFromJSON(jsonValue));
    }

    /**
     */
    async getExternUserByUsername(requestParameters: GetExternUserByUsernameRequest): Promise<UsersDTO> {
        const response = await this.getExternUserByUsernameRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async getUserRaw(requestParameters: GetUserRequest): Promise<runtime.ApiResponse<UsersDTO>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getUser.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("OAuth2", []);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/user/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => UsersDTOFromJSON(jsonValue));
    }

    /**
     */
    async getUser(requestParameters: GetUserRequest): Promise<UsersDTO> {
        const response = await this.getUserRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async getUserByOrcidIDRaw(requestParameters: GetUserByOrcidIDRequest): Promise<runtime.ApiResponse<UsersDTO>> {
        if (requestParameters.orcidId === null || requestParameters.orcidId === undefined) {
            throw new runtime.RequiredError('orcidId','Required parameter requestParameters.orcidId was null or undefined when calling getUserByOrcidID.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.orcidId !== undefined) {
            queryParameters['orcidId'] = requestParameters.orcidId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("OAuth2", []);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/user/findOneByOrcidId`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => UsersDTOFromJSON(jsonValue));
    }

    /**
     */
    async getUserByOrcidID(requestParameters: GetUserByOrcidIDRequest): Promise<UsersDTO> {
        const response = await this.getUserByOrcidIDRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async getUsersRaw(requestParameters: GetUsersRequest): Promise<runtime.ApiResponse<PageUsersDTO>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("OAuth2", []);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/user`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PageUsersDTOFromJSON(jsonValue));
    }

    /**
     */
    async getUsers(requestParameters: GetUsersRequest): Promise<PageUsersDTO> {
        const response = await this.getUsersRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async getUsersByIdsRaw(requestParameters: GetUsersByIdsRequest): Promise<runtime.ApiResponse<{ [key: string]: UsersDTO; }>> {
        if (requestParameters.userIds === null || requestParameters.userIds === undefined) {
            throw new runtime.RequiredError('userIds','Required parameter requestParameters.userIds was null or undefined when calling getUsersByIds.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.userIds) {
            queryParameters['userIds'] = requestParameters.userIds;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("OAuth2", []);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/user/getUsersByIds`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => runtime.mapValues(jsonValue, UsersDTOFromJSON));
    }

    /**
     */
    async getUsersByIds(requestParameters: GetUsersByIdsRequest): Promise<{ [key: string]: UsersDTO; }> {
        const response = await this.getUsersByIdsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async patchUserRaw(requestParameters: PatchUserRequest): Promise<runtime.ApiResponse<UsersDTO>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling patchUser.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("OAuth2", []);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/user/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.patchDocument.map(PatchDocumentToJSON),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => UsersDTOFromJSON(jsonValue));
    }

    /**
     */
    async patchUser(requestParameters: PatchUserRequest): Promise<UsersDTO> {
        const response = await this.patchUserRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchUserRaw(requestParameters: SearchUserRequest): Promise<runtime.ApiResponse<PageUsersDTO>> {
        if (requestParameters.searchParameter === null || requestParameters.searchParameter === undefined) {
            throw new runtime.RequiredError('searchParameter','Required parameter requestParameters.searchParameter was null or undefined when calling searchUser.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.searchParameter !== undefined) {
            queryParameters['searchParameter'] = requestParameters.searchParameter;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("OAuth2", []);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/user/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PageUsersDTOFromJSON(jsonValue));
    }

    /**
     */
    async searchUser(requestParameters: SearchUserRequest): Promise<PageUsersDTO> {
        const response = await this.searchUserRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchUserWithFailedOrcidRaw(requestParameters: SearchUserWithFailedOrcidRequest): Promise<runtime.ApiResponse<PageUsersDTO>> {
        if (requestParameters.searchParameter === null || requestParameters.searchParameter === undefined) {
            throw new runtime.RequiredError('searchParameter','Required parameter requestParameters.searchParameter was null or undefined when calling searchUserWithFailedOrcid.');
        }

        if (requestParameters.institution === null || requestParameters.institution === undefined) {
            throw new runtime.RequiredError('institution','Required parameter requestParameters.institution was null or undefined when calling searchUserWithFailedOrcid.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.searchParameter !== undefined) {
            queryParameters['searchParameter'] = requestParameters.searchParameter;
        }

        if (requestParameters.institution !== undefined) {
            queryParameters['institution'] = requestParameters.institution;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("OAuth2", []);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/user/searchUserWithFailedOrcid`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PageUsersDTOFromJSON(jsonValue));
    }

    /**
     */
    async searchUserWithFailedOrcid(requestParameters: SearchUserWithFailedOrcidRequest): Promise<PageUsersDTO> {
        const response = await this.searchUserWithFailedOrcidRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchUserWithValidOrcidRaw(requestParameters: SearchUserWithValidOrcidRequest): Promise<runtime.ApiResponse<PageUsersDTO>> {
        if (requestParameters.searchParameter === null || requestParameters.searchParameter === undefined) {
            throw new runtime.RequiredError('searchParameter','Required parameter requestParameters.searchParameter was null or undefined when calling searchUserWithValidOrcid.');
        }

        if (requestParameters.institution === null || requestParameters.institution === undefined) {
            throw new runtime.RequiredError('institution','Required parameter requestParameters.institution was null or undefined when calling searchUserWithValidOrcid.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.searchParameter !== undefined) {
            queryParameters['searchParameter'] = requestParameters.searchParameter;
        }

        if (requestParameters.institution !== undefined) {
            queryParameters['institution'] = requestParameters.institution;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("OAuth2", []);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/user/searchUserWithValidOrcid`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PageUsersDTOFromJSON(jsonValue));
    }

    /**
     */
    async searchUserWithValidOrcid(requestParameters: SearchUserWithValidOrcidRequest): Promise<PageUsersDTO> {
        const response = await this.searchUserWithValidOrcidRaw(requestParameters);
        return await response.value();
    }

}
